// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import VueLodash from 'vue-lodash';
import router from './router';
import * as config from './shared/config/config';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import LoginService from './account/login.service';
import AccountService from './account/account.service';
import AlertService from '@/shared/alert/alert.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import GatewayService from '@/admin/gateway/gateway.service';
import TravelPurposeThemeService from '@/visa-application/services/travelpurpose/travel-purpose-theme/travel-purpose-theme.service';
import VisaSubtypeService from '@/visa-application/services/travelpurpose/visa-subtype/visa-subtype.service';
import ApplicationCenterService from '@/visa-application/services/travelpurpose/application-center/application-center.service';
import ResidenceCountryService from '@/visa-application/services/travelpurpose/residence-country/residence-country.service';
import TravelpurposeAvsService from '@/visa-application/services/travelpurpose/avs/avs.service';
import AvsService from '@/visa-application/services/avs/avs/avs.service';
import RegisterService from '@/visa-application/services/account/register.service';
import DirectusService from '@/core/directus/directus.service';
import TlsStoreService from '@/shared/config/service/tls-store.service';
import BasketStoreService from '@/shared/config/service/basket-store.service';
import SchengenService from '@/visa-application/services/schengen/schengen.service';
import AppointementService from '@/visa-application/services/appointment/appointment.service';
import SpecialNeedsService from '@/visa-application/services/special-needs/special-needs.service';
import TlspayService from '@/visa-application/services/tlspay/tlspay.service';
import DirectusSDK from '@directus/sdk-js';
import Faq from '@/info/faq/faq.vue';
import Popup from '@/ui/popup/popup.vue';
import VueMultiselect from 'vue-multiselect';
import SimpleText from '@/ui/popup/simple-text/simple-text.vue';
import TrackMyApplication from '@/ui/popup/track-my-application/track-my-application.vue';
import FormSelection from '@/ui/popup/form-selection/form-selection.vue';
import FormSelectionNew from '@/ui/popup/form-selection-new/form-selection-new.vue';
import ViewForm from '@/ui/popup/view-form/view-form.vue';
import ModifyAddress from '@/ui/popup/modify-address/modify-address.vue';
import FormVisaTypeDocument from '@/ui/popup/form-visatype-document/form-visatype-document.vue';
import SpecialNeeds from './ui/popup/special-needs/special-needs.vue';
import Loading from 'vue-loading-overlay';
import LanguageCode from '@/locale/language-code';
import InquiryService from '@/visa-application/services/inquiry/inquiry.service';
import CaptchaService from '@/visa-application/services/captcha/captcha.service';
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import Meta from 'vue-meta';
import UserAccountService from '@/visa-application/services/account/user-account.service';
import ConsentService from '@/visa-application/services/consent/consent.service';
import VueImgFallback from 'v-img-fallback';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import _ from 'lodash';
import { getLocalStorage } from './shared/utils/utils';
// @ts-ignore
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { datadogRum } from '@datadog/browser-rum';
import XRegExp from 'xregexp';

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
Vue.use(VueImgFallback);
Vue.use(Vue2Filters);
Vue.use(VueLodash);
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(Meta);
Vue.use(VueAwesomeSwiper);
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_ATTR: ['target']
  }
});

Vue.directive('focus', {
  inserted(el) {
    el.focus();
  }
});

const i18n = new VueI18n({
  locale: LanguageCode.EN,
  messages: {
    // @ts-ignore
    'en-us': require('../../resources/i18n/pageContent/en-us'),
    // @ts-ignore
    'fr-fr': require('../../resources/i18n/pageContent/fr-fr'),
    // @ts-ignore
    'it-it': require('../../resources/i18n/pageContent/it-it'),
    // @ts-ignore
    'ar-ar': require('../../resources/i18n/pageContent/ar-ar'),
    // @ts-ignore
    'ru-ru': require('../../resources/i18n/pageContent/ru-ru'),
    // @ts-ignore
    'de-de': require('../../resources/i18n/pageContent/de-de'),
    // @ts-ignore
    'nl-be': require('../../resources/i18n/pageContent/nl-be'),
    // @ts-ignore
    'th-th': require('../../resources/i18n/pageContent/th-th'),
    // @ts-ignore
    'zh-cn': require('../../resources/i18n/pageContent/zh-cn'),
    // @ts-ignore
    'es-es': require('../../resources/i18n/pageContent/es-es'),
    // @ts-ignore
    'hy-am': require('../../resources/i18n/pageContent/hy-am'),
    // @ts-ignore
    'id-id': require('../../resources/i18n/pageContent/id-id'),
    // @ts-ignore
    'pl-pl': require('../../resources/i18n/pageContent/pl-pl'),
    // @ts-ignore
    'pt-pt': require('../../resources/i18n/pageContent/pt-pt'),
    // @ts-ignore
    'sq-sq': require('../../resources/i18n/pageContent/sq-sq'),
    // @ts-ignore
    'sq-al': require('../../resources/i18n/pageContent/sq-al'),
    // @ts-ignore
    'sr-sr': require('../../resources/i18n/pageContent/sr-sr'),
    // @ts-ignore
    'sr-ba': require('../../resources/i18n/pageContent/sr-ba'),
    // @ts-ignore
    'uk-ua': require('../../resources/i18n/pageContent/uk-ua'),
    // @ts-ignore
    'uz-uz': require('../../resources/i18n/pageContent/uz-uz'),
    // @ts-ignore
    'vi-vn': require('../../resources/i18n/pageContent/vi-vn'),
    // @ts-ignore
    'hu-hu': require('../../resources/i18n/pageContent/hu-hu'),
    // @ts-ignore
    'tr-tr': require('../../resources/i18n/pageContent/tr-tr')
  }
});

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Add global components needed here: (<component :is="my-component">)
Vue.component('faq', Faq);
Vue.component('popup', Popup);
Vue.component('simple-text', SimpleText);
Vue.component('track-my-application', TrackMyApplication);
Vue.component('form-selection', FormSelection);
Vue.component('form-selection-new', FormSelectionNew);
Vue.component('view-form', ViewForm);
Vue.component('modify-address', ModifyAddress);
Vue.component('form-visatype-document', FormVisaTypeDocument);
Vue.component('special-needs', SpecialNeeds);
Vue.component('loading', Loading);
Vue.component('multiselect', VueMultiselect);

const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const tlsStoreService = new TlsStoreService(store);
const basketStoreService = new BasketStoreService(store);
const loginService = new LoginService((<any>Vue).cookie, store);
const accountService = new AccountService(store, (<any>Vue).cookie, router);
const directusSDKClient = new DirectusSDK({
  url: window['directus'].endpoint,
  project: '_'
});
const directusService = new DirectusService(directusSDKClient);

const inquiryService = new InquiryService();
const captchaService = new CaptchaService();

router.beforeEach((to, from, next) => {
  if (to.params.issuer && store.getters.issuer !== to.params.issuer) {
    directusService
      .getDetailCodesFromDirectus(to.params.issuer.substr(0, 2) || '', to.params.issuer || '', getLocalStorage('lang'))
      .then(result => {
        directusService.tokensDirectus = result;
      });
    store.commit('issuer', to.params.issuer);
  }
  if (to.params.residenceCountryCode && store.getters.residenceCountryCode !== to.params.residenceCountryCode) {
    directusService
      .getDetailCodesFromDirectus(to.params.residenceCountryCode, to.params.issuer || '', getLocalStorage('lang'))
      .then(result => {
        directusService.tokensDirectus = result;
      });
    store.commit('residenceCountryCode', to.params.residenceCountryCode);
  }

  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta.metaInfo) {
    store.commit('metaInfo', to.meta.metaInfo);
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService
      .asyncHasAnyAuthority(to.meta.authorities)
      .then(result => {
        if (!result) {
          sessionStorage.setItem('requested-url', to.fullPath);
          loginService.goToLogin('', '');
        } else {
          datadogRum.startView({
            name: to.name
          });

          next();
        }
      })
      .catch(error => {
        console.log(error);
      });
  } else {
    // no authorities, so just proceed
    datadogRum.startView({
      name: to.name
    });

    next();
  }
});

Vue.filter('formatDate', function(date: string, language: LanguageCode) {
  const DATE_STRING_REGEX = XRegExp('^\\d{4}-\\d{2}-\\d{2}(T\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?(Z)?)?$');

  if (DATE_STRING_REGEX.test(date)) {
    const options = {
      weekday: 'long',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    };
    return new Intl.DateTimeFormat(language, options).format(new Date(date));
  }
  return '';
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  render: h => h(App),
  router,
  i18n,
  provide: {
    loginService: () => loginService,

    healthService: () => new HealthService(),
    registerService: () => new RegisterService(),
    gatewayService: () => new GatewayService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    tlsStoreService: () => tlsStoreService,
    basketStoreService: () => basketStoreService,
    travelPurposeThemeService: () => new TravelPurposeThemeService(),
    visaSubtypeService: () => new VisaSubtypeService(),
    residenceCountryService: () => new ResidenceCountryService(),
    applicationCenterService: () => new ApplicationCenterService(),
    travelpurposeAvsService: () => new TravelpurposeAvsService(),

    avsService: () => new AvsService(),

    schengenService: () => new SchengenService(),
    appointmentService: () => new AppointementService(),
    specialNeedsService: () => new SpecialNeedsService(),
    tlspayService: () => new TlspayService(),
    userAccountService: () => new UserAccountService(),
    consentService: () => new ConsentService(),

    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,

    directusService: () => directusService,
    inquiryService: () => inquiryService,
    captchaService: () => captchaService
  },
  store,
  metaInfo() {
    const title = _.get(this.$store.getters.metaInfo, 'meta_title', '') ? this.$store.getters.metaInfo.meta_title : 'TLScontact';
    return {
      title: title,
      meta: [
        {
          name: 'title',
          content: title
        },
        {
          name: 'description',
          content: _.get(this.$store.getters.metaInfo, 'meta_description', '')
        },
        {
          name: 'keywords',
          content: _.get(this.$store.getters.metaInfo, 'meta_keywords', '')
        },
        {
          name: 'robots',
          content: _.get(this.$store.getters.metaInfo, 'meta_robots', '')
        }
      ]
    };
  },
  watch: {
    '$store.getters.currentLanguage': {
      handler(newVal) {
        directusService
          .getDetailCodesFromDirectus(getLocalStorage('residenceCountryCode') || '', getLocalStorage('issuer') || '', newVal)
          .then(result => {
            directusService.tokensDirectus = result;
          });
      },
      immediate: true
    }
  }
});
